export enum NotificationPreferencesEnum {
    Email = 0,
    SMS = 1
}